// Canonical sharing-UI template — router-agnostic seams shared by the components.
// The template imports only React; each app injects its router's Link (mapping
// href -> its own navigation) and a renderer for its artifact.

import React from "react";
import type { SharedArtifact } from "./types";

/** A link component the app supplies. Default is a plain anchor (full reload). Pass a
 *  wrapper around your router's Link (mapping href -> to) for SPA navigation. */
export type SharingLinkComponent = React.ComponentType<{ href: string; className?: string; children: React.ReactNode }>;

export const DefaultLink: SharingLinkComponent = ({ href, className, children }) => (
  <a href={href} className={className}>{children}</a>
);

/** How an app renders a shared artifact ({inputJson, outputJson}) for a resource type. */
export type ArtifactRenderer = (artifact: SharedArtifact, resourceType: string) => React.ReactNode;

export type TypeLabeller = (resourceType: string) => string;
export const identityTypeLabel: TypeLabeller = (t) => t;
